import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { Result, Spin } from 'antd';
import moment from "moment";
import { Util } from "common/util";
import { getPayrollForNSSF } from "services/payroll_report";
import withDataTable from "../../withDataTable";

const pathName = "/reports/payroll/payroll_for_nssf";
const columns = [
  {
    title: <div>No&deg;</div>,
    dataIndex: "no",
    key: "no",
    width: 100,
    align: "center",
    render: (no, record, index) => index + 1
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "EMP#",
    dataIndex: "empCode",
    key: "empCode"
  },
  {
    title: "NSSF No.",
    dataIndex: "nssfNumber",
    key: "nssfNumber"
  },
  {
    title: "D.O.B",
    dataIndex: "dob",
    key: "dob",
    align: "center",
    render: dob => moment(dob).format("DD/MM/YYYY")
  },
  {
    title: "Nationality",
    dataIndex: "nationality",
    key: "nationality"
  },
  {
    title: "Employment Date",
    dataIndex: "joinDate",
    key: "joinDate",
    align: "center",
    render: joinDate => moment(joinDate).format("DD/MM/YYYY")
  },
  {
    title: "Team",
    dataIndex: "team",
    key: "team"
  },
  {
    title: "Position",
    dataIndex: "position",
    key: "position"
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: status => {
      const statuses = {0: "New", 1: "Active", 2: "Terminate", 3: "Inactive"};
      if (status >= 0) return statuses[status];
    }
  }
];

const handleSearch = (e) => {
  const value = e.target.value;
  const params = new URLSearchParams(document.location.search);

  if (value) {
    params.set("search", value)
  } else {
    params.delete("search");
  }

  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

const getData = () => {
  let option = {};
  const params = new URLSearchParams(document.location.search);
  if (params.get("date")) option["date"] = params.get("date");
  if (params.get("search")) option["search"] = params.get("search");
  if (params.get("type")) option["type"] = params.get("type");

  if (Object.keys(option).length === 0) {
    return new Promise((resolve) => resolve([]));
  } else {
    return getPayrollForNSSF(option);
  }
};

const componentWillMount = () => {
  const params = new URLSearchParams(document.location.search);
  if (!params.get("date")) params.set("date", moment().format("YYYY-MM"));
  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.has("search")) option["search"] = params.get("search");
    if (params.has("type")) option["type"] = params.get("type");

    option["isExport"] = true;

    getPayrollForNSSF(option)
      .then((response) => {
        console.log(response);
        if (response) {
          setResult(response);
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Successfully exported payroll for bank!"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}
    </>
  );
}

export default withDataTable({
  title: "Payroll Report",
  subTitle: () => {
    const params = new URLSearchParams(document.location.search);
    return params.get("type") === "nssf_pension" ? "NSSF Pension Fund Report" : "NSSF Report";
  },
  backLink: "/reports/payroll",
  showDate: true,
  showExport: true,
  dateFormat: "MM/YYYY",
  datePlaceholder: t("text_mm_yyyy"),
  pathName,
  buttonOption: ExportFormLoader,
  pickerDate: "month",
  customEmptyMessage: t("text_please_select_date_and_employee"),
  columns,
  componentWillMount,
  handleSearch,
  getData,
});
